
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telegram-game",
      function () {
        return require("private-next-pages/telegram-game.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/telegram-game"])
      });
    }
  